// ASIN-Targeting Expression Parser/Builder.
// Amazon-Format: JSON-Array mit { type, value }-Eintraegen.
// Bulk-Sheet-Format: asin="B0...", brand="Name", category="ID".

export type ExpressionType = 'asin' | 'category' | 'brand' | 'refinement' | 'unknown'

export interface ParsedExpression {
  type: ExpressionType
  value: string
  raw: string
}

const EXPR_RE = /^(asin|category|brand|refinement)="?([^"]+)"?$/

export function parseExpression(raw: string): ParsedExpression {
  if (!raw) return { type: 'unknown', value: '', raw }
  const trimmed = raw.trim()

  try {
    const parsed = JSON.parse(trimmed)
    if (Array.isArray(parsed) && parsed.length > 0) {
      const first = parsed[0]
      if (first?.type === 'asinSameAs' || first?.type === 'asin') {
        return { type: 'asin', value: String(first.value), raw }
      }
      if (first?.type === 'asinCategorySameAs' || first?.type === 'queryHighRelMatches') {
        return { type: 'category', value: String(first.value ?? ''), raw }
      }
      if (first?.type === 'asinBrandSameAs' || first?.type === 'queryBroadRelMatches') {
        return { type: 'brand', value: String(first.value ?? ''), raw }
      }
    }
  } catch {
    /* fallback */
  }

  const m = trimmed.match(EXPR_RE)
  if (m) return { type: m[1] as ExpressionType, value: m[2]!, raw }

  return { type: 'unknown', value: trimmed, raw }
}

export function buildAsinExpression(asins: string[]): string {
  return JSON.stringify(asins.map((asin) => ({ type: 'asinSameAs', value: asin })))
}

export function buildCategoryExpression(categoryId: string): string {
  return JSON.stringify([{ type: 'asinCategorySameAs', value: categoryId }])
}

export function buildBrandExpression(brandId: string): string {
  return JSON.stringify([{ type: 'asinBrandSameAs', value: brandId }])
}

export const ASIN_RE = /^B0[A-Z0-9]{8}$/
